export default __webpack_public_path__ + "static/media/driver.f09bb1bc.svg";